import { useSelector } from 'react-redux';

import { NoSearchResults } from '~/components/NoSearchResults/NoSearchResults';
import { centralizedBoardTitleSelector } from '~/store/centralizedBoard/selectors';

export const PublicBoardNoSearchResults = () => {
  const currentBoardTitle = useSelector(centralizedBoardTitleSelector);

  return <NoSearchResults location={currentBoardTitle} />;
};
